import { ActionClickHandler } from './types';

type needDataType = {
  index: number;
  document: number;
  files: Array<any>;
  history: {
    memberId: string;
  };
  status: number;
  actions: {
    rowId: string;
    status: number;
  };
};
export const dataAdapter = (
  data: any,
  handleClick: ActionClickHandler,
  isLoading: boolean,
): needDataType[] => {
  return data.map((item, index) => ({
    index: index + 1,
    document: item.documentType,
    files: item.files,
    history: {
      rowId: item.id,
    },
    status: item.status,
    actions: {
      rowId: item.id,
      status: item.status,
    },
    handleClick,
    isLoading,
  }));
};
